var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 0.667114C2.77533 0.667114 0.166992 3.27545 0.166992 6.50045C0.166992 10.8754 6.00033 17.3338 6.00033 17.3338C6.00033 17.3338 11.8337 10.8754 11.8337 6.50045C11.8337 3.27545 9.22533 0.667114 6.00033 0.667114ZM6.00033 8.58378C4.85033 8.58378 3.91699 7.65045 3.91699 6.50045C3.91699 5.35045 4.85033 4.41711 6.00033 4.41711C7.15033 4.41711 8.08366 5.35045 8.08366 6.50045C8.08366 7.65045 7.15033 8.58378 6.00033 8.58378Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreenIcon);
export default __webpack_public_path__ + "static/media/location-green_icon.960e10fa06e5113789aedb88006369cc.svg";
export { ForwardRef as ReactComponent };